module.exports = __webpack_public_path__ + "img/machinegun.859a71e2.svg";